import React from 'react';
import { connect } from 'react-redux';
import MapperUIWrapper from '../shared/MapperUIWrapper';
import IframePage from '../shared/IframePage';

const NewUploadPage = ({ enableMapperUI }) => {
    if (enableMapperUI) {
        return <MapperUIWrapper />;
    }
    return <IframePage iframePath="" pageName="NewUploadPage" />;;
};

function mapStateToProps(state) {
    return {
        enableMapperUI: state.featureFlag?.data?.EnableMapperUI
    };
}

export default connect(mapStateToProps)(NewUploadPage);
